<template>
  <section id="main-content">
    <h1
      v-if="currentModality==='wildcard'"
    >Indique os professores e/ou professoras que serão responsáveis pelas equipes</h1>
    <h1 v-else>Quantas equipes você pretende ser responsável?</h1>

    <template v-if="currentModality==='wildcard'">
      <ul class="tips small-tips">
        <li
          class="important"
        >Para cada professor(a), você já deve saber quantas serão as equipes supervisionadas. O valor da inscrição será calculado com base nesse número.</li>
        <li>Todos professores e professoras devem pertencer ao corpo docente da escola escolhida: {{chosenSchoolData.NewSuiInstitution.name}}</li>
        <li>Ao final do processo de inscrição os professores e as professoras abaixo indicados receberão convites em seus e-mails. Para montar as equipes, professores e alunos precisam ter criado contas neste site.</li>
      </ul>

      <h2>Cadastro de professores(as)</h2>
      <div id="teacher-adder" class="small-fields">
        <div id="container-name" class="label-input-collator">
          <label for="teachers-name" class="generic-label">Nome</label>
          <input
            placeholder=" "
            class="generic-input"
            type="text"
            id="teachers-name"
            v-model="newTName"
          />
        </div>
        <div id="container-surname" class="label-input-collator">
          <label for="teachers-surname" class="generic-label">Sobrenome</label>
          <input
            placeholder=" "
            class="generic-input"
            type="text"
            id="teachers-surname"
            v-model="newTSurname"
          />
        </div>

        <div id="container-email" class="label-input-collator">
          <label for="teachers-email" class="generic-label">E-mail</label>
          <input
            placeholder=" "
            class="generic-input"
            type="email"
            id="teachers-email"
            v-model="newTEmail"
            v-on:keyup.enter="addTeacherAndSetFocus"
          />
        </div>
        <button class="btn-action btn-fa g" @click="addNewTeacher">
          <font-awesome-icon icon="plus" />
        </button>
      </div>

      <div id="added-teachers-container">
        <div v-for="(teacher, n) in teacherList" v-bind:key="`teacher-${n}`" class="added-teacher">
          <label class="generic-label small-field" :for="`teacher-${n}`">
            Quantas equipes serão supervisionadas por {{teacher.name}} {{teacher.surname}} /
            <a
              :href="`mailto:${teacher.email}`"
            >{{ teacher.email }}</a>?
          </label>
          <input
            :id="`teacher-${n}`"
            type="number"
            min="1"
            class="generic-input"
            v-model="teacher.teams"
          />
          <button class="btn-action" @click="removeTeacher(teacher)">Remover professor(a) responsável</button>
        </div>
        <ul v-if="teacherList.length == 0" class="tips big-tips faded-tips">
          <li>Use a interface acima para adicionar os professores e professoras que serão responsáveis pelas equipes de sua escola.</li>
        </ul>
      </div>
    </template>

    <template v-if="currentModality==='teacher'">
      <ul class="tips">
        <li>Ao final do processo de inscrição será gerado um único boleto correspondendo à inscrição de todas as equipes. Se você quiser gerar boletos separados é preciso repetir o processo de inscrição equipe a equipe.</li>
      </ul>

      <div id="team-adder">
        <label class="generic-label" for="number-of-teams">Número de equipes a se inscrever</label>
        <input id="number-of-teams" type="number" min="1" step="1" class="generic-input" v-model="teacherList[0].teams" />
      </div>
    </template>

    <div id="registration-cost">
      <div id="teachers-were-added" v-if="numberOfTeams > 0">
        <h2>{{numberOfTeams}} equipe{{numberOfTeams !== 1 ? 's' : ''}}</h2>
        <p>Valor total do boleto: R$&#8201;{{registrationCost()}},00</p>
        <small style="color:white;"><em>De acordo com o regulamento (item 5.6.1.9), as primeiras equipes a se inscreverem terão um desconto disponível no valor de 1 boleto após a composição da equipe (professor + 3 membros) ser informada</em></small>
      </div>
      <div id="no-teachers" v-else>
        O custo por equipe é de R$&#8201;{{registrationCost(1)}},00
        <br>ATENÇÃO: É necessário definir quem serão os responsáveis no formulário acima.
        <br><small style="color:white;"><em>De acordo com o regulamento (item 5.6.1.9), as primeiras equipes a se inscreverem terão um desconto disponível no valor de 1 boleto após a composição da equipe (professor + 3 membros) ser informada</em></small>
      </div>
      <button class="btn-main-action" @click="dispatchInvitedTeachers(teacherList)" :disabled="!teacherList.length">Próxima etapa</button>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../../router";
import store from "../../store";

export default {
  name: "StepTeachers",
  computed: {
    ...mapGetters(["currentModality", "chosenSchoolData", "numberOfTeams", "teacherList", "registrationCost"]),
    newTEmail: {
      get: function() {
        return store.state.Subscription.Ephemeral.TeacherToAdd.email;
      },
      set: function(value) {
        store.commit("TEACHER_TO_ADD_CHANGE_EMAIL", value);
      }
    },
    newTName: {
      get: function() {
        return store.state.Subscription.Ephemeral.TeacherToAdd.name;
      },
      set: function(value) {
        store.commit("TEACHER_TO_ADD_CHANGE_NAME", value);
      }
    },
    newTSurname: {
      get: function() {
        return store.state.Subscription.Ephemeral.TeacherToAdd.surname;
      },
      set: function(value) {
        store.commit("TEACHER_TO_ADD_CHANGE_SURNAME", value);
      }
    }
  },
  methods: {
    ...mapActions(["addNewTeacher", "removeTeacher", "goToUserId"]),

    addTeacherAndSetFocus: function() {
      this.addNewTeacher().then(() => {
        let el = document.getElementById("teachers-name");
        el.focus();
      });
    },
    dispatchInvitedTeachers: function(teachers) {
      store.dispatch("registerInvitedTeachers", teachers).then(function() {
        router.push({
          name: "nothingButFlowers",
          params: {
            subsSlug: store.state.Subscription.subscription_slug,
            step: "terms_and_conditions"
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/_mixins.scss";
@import "@/assets/static/css/_definitions.scss";

#teacher-adder,
#team-adder {
  @extend .white-box;
  display: grid;

  padding: pad(-1) pad(0) pad(0);
  margin: pad(0) 0 pad(2);
}

#teacher-adder {
  grid-column-gap: pad(-1);
  grid-row-gap: pad(-1);
  grid-template-columns: 1fr 2fr 2fr min-content;
  align-items: flex-end;

  @include respond-below(md) {
    grid-template-columns: 1fr;
    button {
      margin-top: pad(0);
    }
  }

  position: relative;
}

#added-teachers-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @include respond-between(xs, md) {
    grid-template-columns: repeat(2, 1fr);
  }
  @include respond-below(xs) {
    grid-template-columns: 1fr;
  }

  grid-gap: pad(0);
  margin: pad(1) 0 pad(2);

  ul.tips {
    grid-column: 1 / -1;
  }
}

.added-teacher {
  @extend .white-box;
  background: secondary-color(0);

  border-radius: pad(-2);

  padding: pad(-1) pad(0) pad(0);

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto min-content min-content;
  grid-row-gap: pad(-1);

  align-self: stretch;

  .generic-label {
    align-self: flex-start;
  }
  .btn-action,
  .generic-input {
    align-self: flex-end;
  }

  a {
    word-break: break-all;
  }
}

#registration-cost {
  @extend .white-box;

  box-shadow: none;
  background: grays(1);

  align-items: center;

  #no-teachers {
    color: grays(6);
    font-style: italic;
  }

  #teachers-were-added {
    p,
    h2 {
      color: white;
    }
  }

  display: grid;
  grid-template-columns: 1fr max-content;

  @include respond-below(xs) {
    grid-template-columns: 1fr;
    grid-row-gap: pad(0);
  }
}

.tips + h2 {
  padding-top: pad(1);
}
</style>
